export default {
  swapSummaryTitle: {
    id: 'buyback_swap_summary_cart_title',
    defaultMessage: 'Trade-in',
  },
  swapSummaryContextualMenuMoreInfo: {
    id: 'buyback_swap_summary_cart_contextual_menu_more_info',
    defaultMessage: 'See next steps',
  },
  swapSummaryContextualMenuDelete: {
    id: 'buyback_swap_summary_cart_contextual_menu_delete',
    defaultMessage: 'Remove',
  },
  swapSummaryExpirationDate: {
    id: 'buyback_swap_summary_cart_expiration_date',
    defaultMessage: 'Ship by {date} - Free',
  },
  swapSummaryExpirationDateMailingKit: {
    id: 'buyback_swap_summary_cart_expiration_date_mailing_kit',
    defaultMessage: 'Ship by {date} - Free mailing kit',
  },
  swapSummaryPrice: {
    id: 'buyback_swap_summary_cart_price',
    defaultMessage: 'trade-in value',
  },
}
